module.exports = __webpack_public_path__ + "img/electronic_use_selected.d417d42e.svg";